import {FC, useEffect, useState} from 'react'
import {MasterDataTableTanstack} from '../../../components/DataTable/MasterDataTableTanstack'
import {useIntl} from 'react-intl'
import useUser from '../../../hooks/User'
import {CellContext, ColumnDef} from '@tanstack/react-table'
import {IconButton, Menu, MenuItem} from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import {useDataTableStore} from '../../../stores/DataTableStore'
import useAccessToken from '../../../hooks/AccessToken'
import Swal from 'sweetalert2'
import {InvoiceMultiPageSetting} from '../../../interfaces/Invoices'
import {DeleteInvoice} from '../../../components/Invoices/DeleteInvoice'
import moment from 'moment-timezone'
import axios from 'axios'
import useSWR from 'swr'
import { useSettingsStore } from '../../../stores/SettingsStore'
import { convertWhatsappToHtmlDiv, isColorDarkFromHex } from '../../../functions/general'
import { AddInvoice } from '../../../components/Invoices/AddInvoice'
import { UpdateInvoice } from '../../../components/Invoices/UpdateInvoice'
import useDynamicTab from "../../../hooks/useDynamicTab";
// import "moment/locale/en-gb"; // English (United Kingdom)
// import "moment/locale/en-ca"; // English (Canada)
// import "moment/locale/en-au"; // English (Australia)
// import "moment/locale/en-nz"; // English (New Zealand)
// import "moment/locale/en-in"; // English (India)
import "moment/locale/fr";    // French (default)
// import "moment/locale/fr-ca"; // French (Canada)
// import "moment/locale/fr-ch"; // French (Switzerland)
import "moment/locale/de";    // German (default)
// import "moment/locale/de-at"; // German (Austria)
// import "moment/locale/de-ch"; // German (Switzerland)
import "moment/locale/es";    // Spanish (default)
// import "moment/locale/es-mx"; // Spanish (Mexico)
import "moment/locale/it";    // Italian (default)
// import "moment/locale/it-ch"; // Italian (Switzerland)
import "moment/locale/ja";    // Japanese
import "moment/locale/ko";    // Korean
import "moment/locale/zh-cn"; // Chinese (Simplified)
import "moment/locale/zh-tw"; // Chinese (Traditional)
import "moment/locale/ru";    // Russian
import "moment/locale/ar";    // Arabic
import "moment/locale/id";    // Indonesian

const MasterInvoices: FC = () => {
  const API_URL = process.env.REACT_APP_API_URL
  const intl = useIntl()
  const user = useUser()
  const token = useAccessToken()
  const { settings } = useSettingsStore()
  const {tablesData, selectedFilters, filteredTablesData} = useDataTableStore()

  const [invoice, setInvoice] = useState<InvoiceMultiPageSetting[]>()
  const [selectInvoice, setSelectInvoice] = useState<InvoiceMultiPageSetting>()
  const [showUpdateModal, setShowUpdateModal] = useState<boolean>(false)
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false)
  
  const [openMenuId, setOpenMenuId] = useState<string | null>(null)

  const fetcher = (url: string) => axios.get(url, {
    headers: {
        'X-Auth-token': token
    }
  }).then(res => res.data.data)
  const { data: invoiceData = [], isLoading: invoiceLoading } = useSWR(`${API_URL}invoices/settings`, fetcher)

  useEffect(() => {
    if (!invoiceLoading && invoiceData.length > 0) {
      setInvoice(invoiceData);
      // setInvoice([]);
    }
  }, [invoiceLoading, invoiceData]);

  const handleClick = (menuId: string) => {
    setOpenMenuId(menuId)
  }
  const handleClose = () => {
    setOpenMenuId(null)
  }

  const columns: ColumnDef<any>[] = [
    {
      header: intl.formatMessage({id: 'MASTERS.DATATABLE.COLUMNS.ACTION'}),
      cell: (props: CellContext<any, unknown>) => {
        const row: InvoiceMultiPageSetting = props.row.original
        return (
          <>
            {user.data.is_superadmin && row && (
              <>
                <IconButton
                  aria-label={`more-${row.id}`}
                  id={`menu-anchor-${row.id}`}
                  onClick={() => handleClick(row.id as string)}
                >
                  <MoreVertIcon />
                </IconButton>

                <Menu
                  id={`menu-${row.id}`}
                  anchorEl={document.getElementById(`menu-anchor-${row.id}`)}
                  open={openMenuId === row.id}
                  onClose={handleClose}
                  disableScrollLock={true}
                >
                  <MenuItem
                    onClick={() => {
                      handleClose()
                      setShowUpdateModal(true)
                      setSelectInvoice(row)
                    }}
                  >
                    <i className='fas fa-edit fs-4 me-4'></i>
                    <span>{intl.formatMessage({id: 'FORM.ACTION.UPDATE'})}</span>
                  </MenuItem>

                  <MenuItem
                    onClick={() => {
                      handleClose()
                      setShowDeleteModal(true)
                      setSelectInvoice(row)
                    }}
                  >
                    <i className='fas fa-trash fs-3 me-5'></i>
                    <span>{intl.formatMessage({id: 'FORM.ACTION.DELETE'})}</span>
                  </MenuItem>
                </Menu>
              </>
            )}
          </>
        )
      },
    },
    {
      header: intl.formatMessage({id: 'MASTERS.DATATABLE.COLUMNS.NAME'}),
      accessorKey: 'name',
    },
    {
      header: intl.formatMessage({id: 'FORM.LABEL.TEMPLATE_TITLE'}, {title: settings.pipeline_title}),
      accessorFn: (row) => row.leadTemplate.name,
    },
    {
      header: intl.formatMessage({id: 'MASTERS.DATATABLE.COLUMNS.PROGRESS'}),
      accessorFn: (row) => row.progress.name,
      cell: (props: CellContext<any, unknown>) => {
        const row = props.row.original
        return <strong>{row.progress.name}</strong>
      //   const progressName = row.progress.name;
      //   // const subProgressName = row.lead_subprogress_name;
      //   const progressColor = `#${Math.floor(Math.random() * 16777215).toString(16)}`;

      //   // Determine the badge style based on progress color
      //   const badgeStyle = progressColor
      //       ? { backgroundColor: progressColor, color: isColorDarkFromHex(progressColor) ? "white" : "black" }
      //       : { backgroundColor: "transparent", }; // Default when no color

      //   // Generate badge content
      //   const badgeContent:string = progressName;

      //   // Return the badge component
      //   return (
      //       <BadgeTooltip tooltipText={badgeContent} badgeClass={`my-2 mx-1 ${progressColor ? '' : 'badge-light-info'}`} style={badgeStyle}>
      //           {badgeContent}
      //       </BadgeTooltip>
      //   );
      }
    },
    {
      header: intl.formatMessage({id: 'MASTERS.DATATABLE.COLUMNS.CAPTION'}) + ' WhatsApp',
      accessorKey: 'caption',
      cell: (props: CellContext<any, unknown>) => {
        const row = props.row.original
        return (
          <div 
            style={{ 
              maxWidth: '400px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 4,
              padding: '0'
            }} 
            dangerouslySetInnerHTML={{
            __html: convertWhatsappToHtmlDiv(row.caption),
          }}>
          </div>
        ) 
      },
    },
    {
      id: 'createdAt',
      header: intl.formatMessage({id: 'MASTERS.DATATABLE.TYPE.DATE_CREATED'}),
      cell: (props: CellContext<any, unknown>) => {
          const row = props.row.original
          return <div style={{
            maxWidth: '250px',
            display: "-webkit-box",
            WebkitLineClamp: 4, 
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}>{moment(row.createdAt).format('DD MMM YYYY HH:mm')}</div>
      },
      accessorKey: 'createdAt',
  },
  ]

  const actions = <AddInvoice invoice={invoice} />

  useDynamicTab({ title: `${intl.formatMessage({ id: 'MENU.INVOICES' })} | CRM WooBlazz` });
  

  // useEffect(() => {
  //   if (filteredTablesData.invoices?.length>0) {
  //     console.log('xxxxxxfilteredTablesData', filteredTablesData.invoices)
  //   }
  // }, [filteredTablesData]);

  return (
    <>
      {/* <ol className='breadcrumb text-muted fs-6 fw-bold mb-5'>
        <li className='breadcrumb-item text-dark'>{intl.formatMessage({id: 'MENU.INVOICES'})}</li>
      </ol> */}
      <div className="col-sm-3 col-lg-4 col-xl-5 mb-6" style={{ alignSelf: "center" }}>
          <ol className="breadcrumb text-muted fs-6 fw-bold">
              <li className="breadcrumb-item text-muted">{intl.formatMessage({id:'MENU.STUDIO'})}</li>
              <li className="breadcrumb-item text-dark">{intl.formatMessage({id: 'MENU.INVOICES'})}</li>
          </ol>
      </div>

      <MasterDataTableTanstack
        tableKey='invoices'
        tableColumns={columns}
        actions={[actions]}
        // apiURL='invoices/settings?orderBy=createdAt&orderType=desc'
        apiURL='invoices/settings'
        autoReload={false}
      />

      {selectInvoice && (
        <>
        {showUpdateModal && 
          <UpdateInvoice
            showUpdateModal={showUpdateModal}
            setShowUpdateModal={setShowUpdateModal}
            invoice={selectInvoice}
          />
        }
          <DeleteInvoice
            showDeleteModal={showDeleteModal}
            setShowDeleteModal={setShowDeleteModal}
            invoice={selectInvoice!}
          />
        </>
      )}
    </>
  )
}

export default MasterInvoices
